import React from 'react'
import Alert from '.'
import styles from './styles.module.css'

function AlertSuccess(props) {
  return <Alert className={styles.alertSuccess} {...props} />
}

export default AlertSuccess
